<template>
  <v-dialog
    v-model="model"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :width="width"
    :z-index="modalZIndex"
    :transition="transition"
    :origin="origin"
    :close-on-back="closeOnBack"
    no-click-animation
    :max-width="maxWidth"
    @after-leave="emit('closed')"
  >
    <template #activator="{ props: activatorProps }">
      <slot name="activator" v-bind="{ props: activatorProps }" />
    </template>
    <template #default="{ isActive }">
      <slot name="default" v-bind="{ isActive }" />
    </template>
  </v-dialog>
</template>

<script lang="ts" setup>
import { modalSizes, modalZIndex } from '@manager/config/constants';
import type { IBaseModalProps } from '@manager/modules/modals/modal-types';
import { computed } from 'vue';

const props = withDefaults(defineProps<IBaseModalProps>(), {
  persistent: true,
  fullscreen: false,
  width: 'md',
  maxWidth: undefined,
  transition: 'dialog-bottom-transition',
  origin: 'center center',
  closeOnBack: true,
});

const model = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  /** Emitted when the modal close animation is finished */
  closed: [];
}>();

const width = computed(() => {
  return modalSizes[props.width];
});

const maxWidth = computed(() => {
  return props.maxWidth ? modalSizes[props.maxWidth] : undefined;
});
</script>
